import * as React from "react";
import CTA from "components/mlpaUiComponents/CTA";
import Props from "./index.d";
import { useRecoilValue } from "recoil";
import { isExtendedValiditySubmitBlockedAtom } from "pages/shared/state/extendedValidityState";

const CTASubmitButton: React.FC<Props> = (props) => {
  const {
    disabled,
    testId,
    ctaType,
    data: { setAndSave },
  } = props;

  // Check if submit is blocked due to extended validity flow requirements
  const isExtendedValidityBlocked = useRecoilValue(isExtendedValiditySubmitBlockedAtom);
  const isDisabled = disabled || isExtendedValidityBlocked;

  return (
    <CTA
      ctaType={ctaType}
      disabled={isDisabled}
      label={props.title ?? ""}
      margin={props.margin}
      onClick={() => setAndSave(true)}
      width={props.width}
      data-testid={testId}
    />
  );
};

export default CTASubmitButton;
